class NativeSlider extends HTMLElement {
    connectedCallback() {
        this.container = this.querySelector('.native-slider-container');
        this.prevBtn = this.querySelector('.native-slider-btn--prev');
        this.nextBtn = this.querySelector('.native-slider-btn--next');
        
        if (this.prevBtn) {
            this.prevBtn.addEventListener('click', () => this.scrollAmount(-1));
        }
        if (this.nextBtn) {
            this.nextBtn.addEventListener('click', () => this.scrollAmount(1));
        }
        
        if (this.container) {
            this.container.addEventListener('scroll', () => this.updateButtons(), { passive: true });
            
            // Wait for elements to settle and lay out properly
            setTimeout(() => this.updateButtons(), 150);
            
            // Also listen to resize events to update layout states
            window.addEventListener('resize', () => this.updateButtons(), { passive: true });
        }
    }
    
    scrollAmount(direction) {
        if (!this.container) return;
        const slide = this.container.querySelector('.native-slide');
        const slideWidth = slide ? slide.getBoundingClientRect().width : this.container.clientWidth;
        const gap = parseFloat(window.getComputedStyle(this.container).gap) || 0;
        const scrollStep = slideWidth + gap;
        
        this.container.scrollBy({
            left: direction * scrollStep,
            behavior: 'smooth'
        });
    }
    
    updateButtons() {
        if (!this.container) return;
        const scrollLeft = this.container.scrollLeft;
        const maxScrollLeft = this.container.scrollWidth - this.container.clientWidth;
        
        // 5px threshold to account for subpixel rounding issues in browsers (especially Safari)
        const threshold = 5;
        
        if (this.prevBtn) {
            if (scrollLeft <= threshold) {
                this.prevBtn.setAttribute('disabled', 'true');
                this.prevBtn.classList.add('native-slider-btn--disabled');
            } else {
                this.prevBtn.removeAttribute('disabled');
                this.prevBtn.classList.remove('native-slider-btn--disabled');
            }
        }
        
        if (this.nextBtn) {
            if (scrollLeft >= maxScrollLeft - threshold) {
                this.nextBtn.setAttribute('disabled', 'true');
                this.nextBtn.classList.add('native-slider-btn--disabled');
            } else {
                this.nextBtn.removeAttribute('disabled');
                this.nextBtn.classList.remove('native-slider-btn--disabled');
            }
        }
    }
    
    disconnectedCallback() {
        window.removeEventListener('resize', () => this.updateButtons());
    }
}

if (!customElements.get('native-slider')) {
    customElements.define('native-slider', NativeSlider);
}
